import { defineComponent as _defineComponent } from 'vue'
import { InputIrmao } from '../../../common/types/Irmao'
import ContainerCenter from '@/components/ui/ContainerCenter.vue'
import { aceitarTermosDeUso, recusarTermosDeUso } from '@/services/AuthService'
import LinkDoTermoDeUso from '@/components/auth/LinkDoTermoDeUso.vue'
import ModalDeRecusarTermos from '@/components/auth/ModalDeRecusarTermos.vue'
import { computed, ref } from 'vue'
import { useRouter } from 'vue2-helpers/vue-router'
import { useMutation } from '@tanstack/vue-query'
import { alert, authModule } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'AceiteDeTermos',
  props: {
    usuario: null
  },
  setup(__props: any) {



const termoAceito = ref(false)

const router = useRouter()

const { mutate: recusarMutate, isPending: recusando, isSuccess: recusado } = useMutation({
	mutationFn: () => recusarTermosDeUso(),
	async onSuccess() {
		await authModule.logout();
	},
	onError(error) {
		alert.setError(error);
	},
})

const { mutate: aceitarMutate, isPending: aceitando } = useMutation({
	mutationFn: () => aceitarTermosDeUso(),
	async onSuccess(login) {
		await authModule.logarToken(login)
		router.push({ name: 'home' })
			.catch(() => {})
	},
	onError(error) {
		alert.setError(error);
	},
})

const acoesDesabilitadas = computed(() => recusando.value || aceitando.value || recusado.value)


return { __sfc: true,termoAceito, router, recusarMutate, recusando, recusado, aceitarMutate, aceitando, acoesDesabilitadas, ContainerCenter, LinkDoTermoDeUso, ModalDeRecusarTermos }
}

})